import type { ComponentProps } from 'react';
import React from 'react';
import { Box, Flex, Text } from '@skin-seoul/design-system';
import ProductImage from '../components/ProductImage';
import { Condition } from '../../../utils/react/Condition';
import { useProductCard } from '../ProductCardContext';
import { isNil } from 'es-toolkit';
type ProductCardImageProps = {
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
} & ComponentProps<typeof Box>;
export const HorizontalProductCardImage = ({
  topSlot,
  bottomSlot,
  ...props
}: ProductCardImageProps) => {
  const {
    ranking
  } = useProductCard();
  return <Box position="relative" backgroundColor="neutral.50" width="132px" height="100%" padding="16px" minWidth="132px" alignItems="center" alignSelf="stretch" borderRadius="8px" boxSizing="border-box" {...props} data-sentry-element="Box" data-sentry-component="HorizontalProductCardImage" data-sentry-source-file="HorizontalProductCardImage.tsx">
      <Flex position="absolute" zIndex={2} top={0} left={0} width="100%" data-sentry-element="Flex" data-sentry-source-file="HorizontalProductCardImage.tsx">
        <>{topSlot}</>
      </Flex>
      <ProductImage data-sentry-element="ProductImage" data-sentry-source-file="HorizontalProductCardImage.tsx" />
      <Condition expression={!isNil(ranking)} then={<Flex position="absolute" top={0} left={0} h={12} w={12} alignItems="center" justifyContent="center">
            <Text color="neutral.200" textStyle="heading.h2">
              {ranking}
            </Text>
          </Flex>} data-sentry-element="Condition" data-sentry-source-file="HorizontalProductCardImage.tsx" />
      <Flex position="absolute" bottom={0} zIndex={2} left={0} width="100%" data-sentry-element="Flex" data-sentry-source-file="HorizontalProductCardImage.tsx">
        <>{bottomSlot}</>
      </Flex>
    </Box>;
};